"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PagesTable_1 = __importDefault(require("../components/PagesTable"));
const URLs_1 = require("../utility/URLs");
const helpers_1 = require("../../commonFiles/helpers");
const Filters_1 = require("../components/Filters");
const react_bootstrap_1 = require("react-bootstrap");
const ChangePageTitle_1 = __importDefault(require("../../commonFiles/ChangePageTitle"));
const Paginator_1 = __importDefault(require("../../commonFiles/Paginator"));
function PagesIndex(props) {
    // const history = useHistory()
    const [pagesPagination, setpagesPagination] = react_1.default.useState();
    const [books, setbooks] = react_1.default.useState([]);
    function fetchBooks() {
        (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.fetchBooks({ withoutPagination: true }); }), (data) => { setbooks(data); }, 'PagesIndex fetchBooks', true);
    }
    react_1.default.useEffect(() => {
        // var params = Object.fromEntries(new URLSearchParams(location.search));
        // fetchPages(null, params)
        fetchBooks();
    }, []);
    function deletePage(id) {
        (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.deletePage(id); }), (data) => {
            // fetchPages()
        }, 'PagesIndex deletePage', true);
    }
    function fetch(params) {
        return URLs_1.Api.fetchPages(Object.assign(Object.assign(Object.assign({}, (0, Filters_1.getPaginationParams)(pagesPagination)), { orderById: true }), params));
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'd-flex align-items-center fs-4 ' },
            react_1.default.createElement("i", { className: "bi bi-book" }),
            react_1.default.createElement("div", { className: 'mx-2' }, "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0635\u0641\u062D\u0627\u062A")),
        react_1.default.createElement("div", { className: 'bg-white rounded shadow m-3 p-4' },
            react_1.default.createElement(ChangePageTitle_1.default, { pageTitle: 'قائمة الصفحات' }),
            react_1.default.createElement("div", { className: 'd-flex' },
                react_1.default.createElement(Filters_1.TextFilter2, { apiCall: fetch, property: 'title', label: 'عنوان الصفحة', useState: [pagesPagination, setpagesPagination] }),
                react_1.default.createElement(Filters_1.SelectFilter, { options: books, apiCall: fetch, property: 'book_id', label: 'احتر كتاب', defaultValue: null, valueKeyWord: 'id', nameKeyWord: 'title', useState: [pagesPagination, setpagesPagination] })),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 12 },
                react_1.default.createElement(PagesTable_1.default, { pages: pagesPagination === null || pagesPagination === void 0 ? void 0 : pagesPagination.data, deletePage: deletePage })),
            react_1.default.createElement(Paginator_1.default, { log: 'FETCH pages', apiCall: fetch, useState: [pagesPagination, setpagesPagination] }))));
}
exports.default = PagesIndex;
